<template>
  <div class="container">
    <div class="section">
      <label>Type:</label>
      <input disabled="disabled" value="Referral" />
    </div>
    <div class="section">
      <label>Country:</label>
      <select name="country" v-model="country">
        <option value="LT">{{ countryName("LT") }}</option>
        <option value="PL">{{ countryName("PL") }}</option>
      </select>
    </div>
    <div class="section">
      <label>Currency:</label>
      <input disabled="disabled" :value="currency" />
    </div>
    <div class="section">
      <label>Date range:</label>
      <DatePicker v-model="range" is-range mode="datetime" />
    </div>
    <div class="section">
      <label>Promo limit:</label>
      <input type="number" min="1" v-model="maxCodes" />
    </div>
    <div class="section">
      <label>Claims per Promo:</label>
      <input type="number" min="1" v-model="maxClaimsPerCode" />
    </div>
    <div class="section">
      <label>Referring user discount ({{ currency }}):</label>
      <input type="number" step="0.01" v-model="referringUserDiscountAmount" />
    </div>
    <div class="section">
      <label>New user discount ({{ currency }}):</label>
      <input type="number" step="0.01" v-model="referredUserDiscountAmount" />
    </div>
    <p v-if="errorMessage" class="error">Error: {{ errorMessage }}</p>
    <button v-on:click="createCampaign()">Create campaign</button>
  </div>
</template>

<style scoped lang="less">
.container {
  padding: 50px;
}
label {
  margin-right: 20px;
}
input {
  padding: 10px;
}
.section {
  margin-bottom: 20px;
}
button {
  margin-top: 10px;
  border: 1px solid black;
  padding: 10px;
  cursor: pointer;
}
.error {
  color: red;
}
</style>


<script>
import api from "@/services/api";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
  name: "createReferralCampaign",
  components: { DatePicker },
  data() {
    const startsAt = new Date();
    startsAt.setHours(0, 0, 0, 0); // beginning of current day
    const endsAt = new Date(startsAt.getFullYear(), startsAt.getMonth() + 1, 0); // end of current month

    return {
      country: "LT",
      range: { start: startsAt, end: endsAt },
      maxCodes: 500,
      maxClaimsPerCode: 5,
      referringUserDiscountAmount: 20,
      referredUserDiscountAmount: 20,

      errorMessage: "",
    };
  },
  computed: {
    currency() {
      return this.country === "PL" ? "PLN" : "EUR";
    },
  },
  methods: {
    async createCampaign() {
      try {
        await api.createReferralCampaign({
          country: this.country,
          startsAt: this.range.start.toISOString(),
          endsAt: this.range.end.toISOString(),
          maxCodes: this.maxCodes,
          maxClaimsPerCode: this.maxClaimsPerCode,
          referringUserDiscountAmount: this.referringUserDiscountAmount * 100,
          referredUserDiscountAmount: this.referredUserDiscountAmount * 100,
        });
        this.$router.push("/campaigns");
      } catch (error) {
        this.errorMessage =
          (error.response && error.response.data) || `unexpected: ${error}`;
      }
    },
    countryName(country) {
      return Intl.DisplayNames
        ? new Intl.DisplayNames(["en"], { type: "region" }).of(country)
        : country;
    },
  },
};
</script>
